import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Container, Col, Row, Tab, Carousel } from 'react-bootstrap';
import { LazyLoadImage } from 'react-lazy-load-image-component';

function Work() {
    window.scrollTo(0, 0);
    return (

        <div>
            <Helmet>
                <title>Luxury Digital Marketing Agency Case Studies - A&B</title>
                <meta name="description" content="A&B Work Page" />
                <link rel="canonical" href="https://anbluxury.com/work.html" />

            </Helmet>

            <div className="work bgbl padmsmt padmsmb " >
                <Col lg="10" className="offset-lg-1" >
                    <h3><span className="spund">Ou</span>r Work</h3>
                </Col>
                {/* for desktop */}
                <Container className="work2 padmsmt ">
                    <div className="imgrow">
                        <div className="imgcolumn2">

                            <div className="bg">
                                <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/ADANI-REALTY.avif`} alt="" height="100%" width="100%" />
                                <div className="centeredbox"><h4>$1 Million Homes, Sold to Multi-Millionaires</h4>
                                    <Link to={`${process.env.PUBLIC_URL}/case-studies/adani-realty-case-study.html`}>View Case Study &gt;</Link></div>
                                <div className="overlay">
                                    <h1>
                                        ADANI REALTY <br />
                                    </h1>
                                    <h2>
                                        <Link to={`${process.env.PUBLIC_URL}/case-studies/adani-realty-case-study.html`}>
                                            <u>$1 Million Homes, Sold to Multi-Millionaires</u>
                                        </Link>
                                    </h2>
                                    {/* <p>View Case Study</p> */}
                                </div>
                            </div>


                            <div className="bg">
                                <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casaire1.avif`} alt="" height="100%" width="100%" />
                                <div className="centeredbox"><h4>Luxury Furniture Brand Dubai - Walkins up by 400%</h4>
                                    <Link to={`${process.env.PUBLIC_URL}/case-studies/dubai-luxury-furniture-store-walkin-case-study.html`}>View Case Study &gt;</Link></div>
                                <div className="overlay">
                                    <h1>
                                        CASAIRE <br />
                                    </h1>
                                    <h2>
                                        <Link to={`${process.env.PUBLIC_URL}/case-studies/dubai-luxury-furniture-store-walkin-case-study.html`}>
                                            <u>Luxury Furniture Brand Dubai - Walkins up by 400%</u>
                                        </Link> </h2>

                                    {/* <p>View Case Study</p> */}
                                </div>
                            </div>


                            <div className="bg">
                                <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/Parfait.avif`} alt="" height="100%" width="100%" />
                                <div className="centeredbox"><h4>Magazine covers became size inclusive with<br /> just a lens!</h4>
                                    <Link to={`${process.env.PUBLIC_URL}/case-studies/parfait-snapchat-instagram-case-study.html`}>View Case Study &gt;</Link></div>
                                <div className="overlay">
                                    <h1>
                                        Parfait <br />
                                    </h1>
                                    <h2>
                                        <Link to={`${process.env.PUBLIC_URL}/case-studies/parfait-snapchat-instagram-case-study.html`}>
                                            <u>Magazine covers became size inclusive with just a lens!</u>
                                        </Link>
                                        <br /></h2>
                                    {/* <p>View Case Study</p> */}
                                </div>
                            </div>

                            {/*
                           <div className="bg">
                                <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/Tiranga-Dabba.avif`} alt="" height="100%" width="100%" />
                                <div className="centeredbox"><h4>Restoring the dignity of hundreds of<br /> national flags</h4>
                                    <Link to={`${process.env.PUBLIC_URL}/case-studies/independence-day-social-media-campaign-tiranga-dabba.html`}>View Case Study &gt;</Link></div>
                                <div className="overlay">
                                    <h1>
                                        Tiranga Dabba <br />
                                    </h1>
                                    <h2>
                                        <Link to={`${process.env.PUBLIC_URL}/case-studies/independence-day-social-media-campaign-tiranga-dabba.html`}>
                                            <u>Restoring the dignity of hundreds of national flags</u>
                                        </Link>
                                        <br /></h2>
                                     <p>View Case Study</p> 
                                </div>
                            </div>

                            */

                            }

                            <div className="bg">
                                <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/Nova-Kid.avif`} alt="" height="100%" width="100%" />
                                <div className="centeredbox"><h4>418% jump in Revenue via Advertising, highest revenue post launch in India ever. </h4>
                                    <Link to={`${process.env.PUBLIC_URL}/case-studies/digital-advertising-sales-growth-case-study.html`}>View Case Study &gt;</Link></div>
                                <div className="overlay">
                                    <h1>
                                        NOVA KID<br />
                                    </h1>
                                    <h2>
                                        <Link to={`${process.env.PUBLIC_URL}/case-studies/digital-advertising-sales-growth-case-study.html`}>
                                            <u>418% jump in Revenue via Advertising, highest revenue post launch in India ever. </u>
                                        </Link> </h2>

                                    {/* <p>View Case Study</p> */}
                                </div>
                            </div>

                            <div className="bg">
                                <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/Evok1.avif`} alt="" height="100%" width="100%" />
                                <div className="centeredbox"><h4>1.47 M targeted users engaged through social media.</h4>
                                    <Link to={`${process.env.PUBLIC_URL}/case-studies/social-media-case-study-evok-furnitures.html`}>View Case Study &gt;</Link></div>
                                <div className="overlay">
                                    <h1>
                                        EVOK <br />
                                    </h1>
                                    <h2>
                                        <Link to={`${process.env.PUBLIC_URL}/case-studies/social-media-case-study-evok-furnitures.html`}>
                                            <u>1.47 M targeted users engaged through social media.</u>
                                        </Link> </h2>

                                    {/* <p>View Case Study</p> */}
                                </div>
                            </div>


                        </div>

                        <div className="imgcolumn2">


                            <div className="bg">
                                <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/aprilia-rs457.avif`} alt="" height="100%" width="100%" />
                                <div className="centeredbox"><h4>Thousands of prebookings and billions <br></br> of rupees of revenue.</h4>
                                    <Link to={`${process.env.PUBLIC_URL}/case-studies/aprilia-rs457-launch-case-study.html`}>View Case Study &gt;</Link></div>
                                <div className="overlay">
                                    <h1>
                                        Aprilia 457’s Launch <br />
                                    </h1>
                                    <h2>
                                        <Link to={`${process.env.PUBLIC_URL}/case-studies/aprilia-rs457-launch-case-study.html`}>
                                            <u>Thousands of prebookings and billions of rupees of revenue.</u>
                                        </Link> </h2>

                                    {/* <p>View Case Study</p> */}
                                </div>
                            </div>







                            <div className="bg">
                                <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/Isaia.avif`} alt="" height="100%" width="100%" />
                                <div className="centeredbox"><h4>100% Jump in Walkin Revenue in 4 Months</h4>
                                    <Link to={`${process.env.PUBLIC_URL}/case-studies/isaia-retail-store-digital-transformation.html`}>View Case Study &gt;</Link></div>
                                <div className="overlay">
                                    <h1>
                                        ISAIA <br />
                                    </h1>
                                    <h2>
                                        <Link to={`${process.env.PUBLIC_URL}/case-studies/isaia-retail-store-digital-transformation.html`}>
                                            <u>100% Jump in Walkin Revenue in 4 Months</u>
                                        </Link>
                                    </h2>
                                    {/* <p>View Case Study</p> */}
                                </div>
                            </div>

                            <div className="bg">
                                <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/Saundh.avif`} alt="" height="100%" width="100%" />
                                <div className="centeredbox"><h4>Improvement in E-Commerce <br /> Conversion Rate.</h4>
                                    <Link to={`${process.env.PUBLIC_URL}/case-studies/ecommerce-conversion-rate-case-study.html`}>View Case Study &gt;</Link></div>
                                <div className="overlay">
                                    <h1>
                                        SAUNDH <br />
                                    </h1>
                                    <h2>
                                        <Link to={`${process.env.PUBLIC_URL}/case-studies/ecommerce-conversion-rate-case-study.html`}>
                                            <u>Improvement in E-Commerce <br /> Conversion Rate.</u>
                                        </Link>
                                    </h2>
                                    {/* <p>View Case Study</p> */}
                                </div>
                            </div>
                            <div className="bg">
                                <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/Limelight.avif`} alt="" height="100%" width="100%" />
                                <div className="centeredbox"><h4>780% ROI via Digital, scaled non existent<br /> e-commerce.</h4>
                                    <Link to={`${process.env.PUBLIC_URL}/case-studies/ecommerce-advertising-case-study.html`}>View Case Study &gt;</Link></div>
                                <div className="overlay">
                                    <h1>
                                        LIMELIGHT <br />
                                    </h1>
                                    <h2>
                                        <Link to={`${process.env.PUBLIC_URL}/case-studies/ecommerce-advertising-case-study.html`}>
                                            <u>780% ROI via Digital,<br /> scaled non existent e-commerce.</u>
                                        </Link>
                                    </h2>
                                    {/* <p>View Case Study</p> */}
                                </div>
                            </div>

                            <div className="bg">
                                <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/dhruv-kapoor.jpg`} alt="" height="100%" width="100%" />
                                <div className="centeredbox"><h4>Unlocking Global Potential: 382% Surge in International Orders for Dhruv Kapoor</h4>
                                    <Link to={`${process.env.PUBLIC_URL}/case-studies/dhruv-kapoor-case-study.html`}>View Case Study &gt;</Link></div>
                                <div className="overlay">
                                    <h1>
                                        DHRUV KAPOOR <br />
                                    </h1>
                                    <h2>
                                        <Link to={`${process.env.PUBLIC_URL}/case-studies/dhruv-kapoor-case-study.html`}>
                                            <u>Unlocking Global Potential: 382% Surge in International Orders for Dhruv Kapoor</u>
                                        </Link> </h2>

                                    {/* <p>View Case Study</p> */}
                                </div>
                            </div>

                            <div className="bg" style={{ display: 'none' }}>
                                <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/bonnie-brand.png`} alt="" height="100%" width="100%" />
                                <div className="centeredbox"><h4>525% Growth in Architect & Interior Designer Leads: The Bonnie & Saks Story</h4>
                                    <Link to={`${process.env.PUBLIC_URL}/case-studies/bonnie-and-saks-case-study.html`}>View Case Study &gt;</Link></div>
                                <div className="overlay">
                                    <h1>
                                        BONNIE & SAKS<br />
                                    </h1>
                                    <h2>
                                        <Link to={`${process.env.PUBLIC_URL}/case-studies/bonnie-and-saks-case-study.html`}>
                                            <u>525% Growth in Architect & Interior Designer Leads: The Bonnie & Saks Story</u>
                                        </Link> </h2>

                                    {/* <p>View Case Study</p> */}
                                </div>
                            </div>

                            <div className="bg" style={{ display: 'none' }}>
                                <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/bonnie-brand.png`} alt="" height="100%" width="100%" />
                                <div className="centeredbox"><h4>100% Growth in Lab-Grown
                                    Diamond Orders within 4 months in KSA</h4>
                                    <Link to={`${process.env.PUBLIC_URL}/case-studies/eternal-case-study.html`}>View Case Study &gt;</Link></div>
                                <div className="overlay">
                                    <h1>
                                        ETERNAL<br />
                                    </h1>
                                    <h2>
                                        <Link to={`${process.env.PUBLIC_URL}/case-studies/eternal-case-study.html`}>
                                            <u>100% Growth in Lab-Grown
                                                Diamond Orders within 4 months in KSA</u>
                                        </Link> </h2>

                                    {/* <p>View Case Study</p> */}
                                </div>
                            </div>
                            <div className="bg" style={{ display: 'none' }}>
                                <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/bonnie-brand.png`} alt="" height="100%" width="100%" />
                                <div className="centeredbox"><h4>100% Growth in Lab-Grown
                                    Diamond Orders within 4 months in KSA</h4>
                                    <Link to={`${process.env.PUBLIC_URL}/case-studies/tin-tone-and-shade-study.html`}>View Case Study &gt;</Link></div>
                                <div className="overlay">
                                    <h1>
                                        TIN TONE AND SHADE<br />
                                    </h1>
                                    <h2>
                                        <Link to={`${process.env.PUBLIC_URL}/case-studies/tin-tone-and-shade-study.html`}>
                                            <u>100% Growth in Lab-Grown
                                                Diamond Orders within 4 months in KSA</u>
                                        </Link> </h2>

                                    {/* <p>View Case Study</p> */}
                                </div>
                            </div>


                        </div>

                        <div className="imgcolumn2">

                            <div className="bg">
                                <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/1seagallery.avif`} alt="" height="100%" width="100%" />
                                <div className="centeredbox"><h4>438% jump in qualified inquiries in 12 months</h4>
                                    <Link to={`${process.env.PUBLIC_URL}/case-studies/online-lead-generation-case-study.html`}>View Case Study &gt;</Link></div>
                                <div className="overlay ">
                                    <h1>
                                        Atmantan<br />
                                    </h1>
                                    <h2>
                                        <Link to={`${process.env.PUBLIC_URL}/case-studies/online-lead-generation-case-study.html`}>
                                            <u>438% jump in qualified inquiries in 12 months</u>
                                        </Link>
                                        <br />
                                    </h2>

                                </div>
                            </div>


                            <div className="bg">
                                <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/paytmInsider.avif`} alt="" height="100%" width="100%" />
                                <div className="centeredbox"><h4>430% increase in organic traffic, and 200% lift in conversions.</h4>
                                    <Link to={`${process.env.PUBLIC_URL}/case-studies/seo-case-study-for-event-ticketing-company.html`}>View Case Study &gt;</Link></div>
                                <div className="overlay">
                                    <h1>Insider<br /></h1>
                                    <h2>
                                        <Link to={`${process.env.PUBLIC_URL}/case-studies/seo-case-study-for-event-ticketing-company.html`}>
                                            <u>400% increase in organic traffic, and 200% lift in conversions.</u>
                                        </Link></h2>
                                    {/* <p>View Case Study</p> */}
                                </div>
                            </div>

                            <div className="bg">
                                <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/Evok.avif`} className="customtint" alt="" height="100%" width="100%" />
                                <div className="centeredbox"><h4>Scaled  Ecommerce Revenue by 2404%</h4>
                                    <Link to={`${process.env.PUBLIC_URL}/case-studies/scaling-evok-ecommerce-revenue.html`}>View Case Study &gt;</Link></div>
                                <div className="overlay">
                                    <h1>Evok <br /></h1>
                                    <h2>
                                        <Link to={`${process.env.PUBLIC_URL}/case-studies/scaling-evok-ecommerce-revenue.html`}>
                                            <u>Scaled  Ecommerce Revenue by 2404%</u>
                                        </Link></h2>
                                    {/* <p>View Case Study</p> */}
                                </div>
                            </div>



                            <div className="bg">
                                <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/Blabel.avif`} alt="" height="100%" width="100%" />
                                <div className="centeredbox"><h4>1043% increase in unique blogs pageviews</h4>
                                    <Link to={`${process.env.PUBLIC_URL}/case-studies/content-marketing-case-study-increase-in-pageviews.html`}>View Case Study &gt;</Link></div>
                                <div className="overlay">
                                    <h1>
                                        BLABEL <br />
                                    </h1>
                                    <h2>
                                        <Link to={`${process.env.PUBLIC_URL}/case-studies/content-marketing-case-study-increase-in-pageviews.html`}>
                                            <u>1043% increase in unique blogs pageviews</u>
                                        </Link> </h2>

                                    {/* <p>View Case Study</p> */}
                                </div>
                            </div>




                            <div className="bg" style={{ display: 'none' }}>
                                <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/scarlet-brand.png`} alt="" height="100%" width="100%" />
                                <div className="centeredbox"><h4>From Niche to Global Preference: A 400% Rise in Architect & Interior Designer Leads for Scarlet Splendour</h4>
                                    <Link to={`${process.env.PUBLIC_URL}/case-studies/scarlet-splendour-case-study.html`}>View Case Study &gt;</Link></div>
                                <div className="overlay">
                                    <h1>
                                        SCARLET SPLENDOUR <br />
                                    </h1>
                                    <h2>
                                        <Link to={`${process.env.PUBLIC_URL}/case-studies/scarlet-splendour-case-study.html`}>
                                            <u>From Niche to Global Preference: A 400% Rise in Architect & Interior Designer Leads for Scarlet Splendour</u>
                                        </Link> </h2>

                                    {/* <p>View Case Study</p> */}
                                </div>
                            </div>






                        </div>


                    </div>
                </Container>

            </div>
        </div>
    )
}

export default Work;